module.exports = __webpack_public_path__ + "static/media/rescore_tech_logo_en.d93c3228.jpg";